<template>
    <div ref="textMore" :class="['text-more', isExpand ? 'expand' : '']">
        {{ content }}
        <div v-if="isExpandBtn" class="btn-more color-base underline" @click="isExpand = !isExpand">{{ !isExpand ? '展开' :
            '收起' }}</div>
    </div>
</template>
<script>
export default {
    props: {
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isExpand: false, // 是否展开
            isExpandBtn: false, // 是否显示展开按钮
        }
    },
    watch: {
        content: {
            immediate: true,
            handler(value) {
                if (value) this.checkTextOverflow();
            },
        },
    },
    methods: {
        // 检查文本是否超过2行，如果是，则显示展开按钮
        checkTextOverflow() {
            this.$nextTick(() => {
                var textContainer = this.$refs['textMore'];
                if (textContainer.scrollHeight > textContainer.clientHeight) this.isExpandBtn = true;
            })
        },

    }
};
</script>
<style lang="scss" scoped>
.text-more {
    height: 42px;
    overflow: hidden;
    position: relative;
    transition: height 2s ease-in;

    .btn-more {
        position: absolute;
        right: 0px;
        bottom: 0px;
        background-color: $--color-white;
        padding-left: 20px;
        cursor: pointer;

        &:hover {
            opacity: 1;
        }

        &::before {
            content: "...";
            position: absolute;
            left: 0px;
            top: 0px;
            color: $-text-950;
            font-weight: normal;
        }
    }

    &.expand {
        height: auto;

        .btn-more {
            width: auto;

            &::before {
                display: none;
            }
        }
    }
}
</style>
